module.exports = __webpack_public_path__ + "img/banner04_info_pic5.d1f3631a.jpg";